import React from 'react'
import {Link} from 'react-router-dom'

import Component from '../../components/Component'

import User from '../../models/User'
import {Img} from "react-image";
import LoadingSpinner from "../../components/LoadingSpinner";
import UserImageCircle from "../../components/UserImageCircle";

export default class TeamMemberPanel extends Component {

    render() {
        let {
            team,
            project,
            position,
            member
        } = this.props;
        let user = member ? User.make({...member}) : null;

        let linkParams = {
            project_id: project.id
        };
        if (team) {
            linkParams.team_id = team.id
        }

        return (
            <div className="team-member-panel">

                <div className="top-panel">

                    {user ? (
                        <Link className={TB.mapClass("text-decoration-none", {
                            'no-click': this.props.disabled
                        })} to={`talent-profiles/${user.id}`} state={{
                            linkParams: this.props.linkParams
                        }}>
                            <div className="profile-image-container">
                                <Img
                                    loader={(
                                        <div
                                            className="self-stretch justify-center items-center flex flex-col">
                                            <LoadingSpinner/>
                                        </div>
                                    )}
                                    unloader={<UserImageCircle user={user} hideTooltip={true} size={80}/>}
                                    src={user.image_path}
                                    className="img-grayscale profile-image"/>
                            </div>
                            <p className="member-user-name">
                                {user.firstNamePlusInitial()}
                            </p>
                            <p className="member-user-title">
                                {TB.isObject(position) ? position.title : user.title}
                            </p>

                            <p className="member-user-title">
                                email@email.com {/* need from member response */}
                            </p>

                        </Link>
                    ) : (
                        <div className="text-decoration-none">
                            <div>
                                <div className="flex items-center justify-center m-auto profile-image">
                                    <i className="fa fa-user text-center text-muted"
                                       style={{fontSize: 50}}/>
                                </div>

                            </div>

                            <p className="member-user-name">
                                Unassigned
                            </p>
                            {TB.isObject(position) && (
                                <p className="member-user-title">
                                    {position.title}
                                </p>
                            )}
                        </div>
                    )}
                </div>


            </div>
        );
    }
}